<app-loading *ngIf="contentReady"></app-loading>

<section class="book-service-page" style="margin-bottom: 100px;" *ngIf="!contentReady">
  <div class="book-hero">
    <div>
      <p class="book-kicker">
        {{ isAr ? 'عيادة بلوبوكس ' : 'Blue Box Clinic' }}
      </p>

      <h1>
        {{ isAr ? 'حجز خدمة العيادة' : 'Book Clinic Service' }}
      </h1>

      <p class="book-subtitle">
        {{
          isAr
            ? 'احجز كشف، تطعيم، عملية أو جرومينج بسهولة وسيتم التواصل معك لتأكيد المعاد'
            : 'Book a checkup, vaccine, surgery or grooming service easily'
        }}
      </p>
    </div>

    <div class="hero-badge">
  <img src="/assets/e-commerce/icons/93.webp" style="width: 50px;" alt="العيادة">
      <strong>{{ isAr ? 'حجز سريع' : 'Fast Booking' }}</strong>
    </div>
  </div>

  <div class="book-layout">
    <div class="selected-service-card" *ngIf="service">
      <div class="service-icon">
        🐾
      </div>

      <p class="small-title">
        {{ isAr ? 'الخدمة المختارة' : 'Selected Service' }}
      </p>

      <h2>{{ serviceTitle }}</h2>

      <p class="service-desc" *ngIf="serviceDescription">
        {{ serviceDescription }}
      </p>

      <div class="service-price" *ngIf="servicePrice">
        <span>{{ isAr ? 'السعر' : 'Price' }}</span>
        <strong>{{ servicePrice }} {{ isAr ? 'جنيه' : 'EGP' }}</strong>
      </div>
    </div>

    <form class="booking-card" [formGroup]="bookingForm" (ngSubmit)="submitBooking()">
      <input type="hidden" formControlName="pet_service_id" />
      <input type="hidden" formControlName="from_website" />

      <div class="form-header">
        <h3>
          {{ isAr ? 'بيانات الحجز' : 'Booking Details' }}
        </h3>

        <p>
          {{
            tokenExists
              ? (isAr ? 'اختار نوع الحيوان والمعاد المناسب فقط' : 'Choose pet type and appointment only')
              : (isAr ? 'اكتب بياناتك ومعاد مناسب للحجز' : 'Enter your details and preferred appointment time')
          }}
        </p>
      </div>

      <div class="logged-user-card" *ngIf="tokenExists">
        <div>
          <strong>{{ isAr ? 'الحجز بحسابك الحالي' : 'Booking with your account' }}</strong>
          <p>
            {{ client_name }} 
            <span *ngIf="phone_number"> - {{ phone_number }}</span>
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mb-3">
          <label>
            {{ isAr ? 'نوع الحيوان الأليف' : 'Pet Type' }}
          </label>

          <select class="form-control" formControlName="pet_type">
            <option *ngFor="let type of petTypes" [value]="type.value">
              {{ isAr ? type.ar : type.en }}
            </option>
          </select>

          <div
            class="text-danger mt-1"
            *ngIf="bookingForm.controls['pet_type'].touched && bookingForm.controls['pet_type'].invalid"
          >
            {{ isAr ? 'اختار نوع الحيوان' : 'Choose pet type' }}
          </div>
        </div>

        @if(!tokenExists) {
          <div class="col-md-12 mb-3">
            <label>
              {{ isAr ? 'اسم العميل' : 'Client Name' }}
            </label>

            <input
              class="form-control"
              type="text"
              formControlName="client_name"
              [placeholder]="isAr ? 'اكتب اسمك' : 'Enter your name'"
              [ngClass]="{
                'is-invalid':
                  bookingForm.controls['client_name'].touched &&
                  bookingForm.controls['client_name'].errors,
                'is-valid':
                  bookingForm.controls['client_name'].touched &&
                  !bookingForm.controls['client_name'].errors
              }"
            />

            <div
              class="text-danger mt-1"
              *ngIf="bookingForm.controls['client_name'].touched && bookingForm.controls['client_name'].invalid"
            >
              {{ isAr ? 'اكتب اسمك' : 'Enter your name' }}
            </div>
          </div>

          <div class="col-md-12 mb-3">
            <label>
              {{ isAr ? 'رقم الموبايل' : 'Phone Number' }}
            </label>

            <input
              class="form-control"
              type="text"
              maxlength="11"
              inputmode="numeric"
              pattern="[0-9]*"
              formControlName="phone_number"
              (keypress)="onlyNumbers($event)"
              [placeholder]="isAr ? 'مثال: 01000000000' : 'Example: 01000000000'"
              [ngClass]="{
                'is-invalid':
                  bookingForm.controls['phone_number'].touched &&
                  bookingForm.controls['phone_number'].errors,
                'is-valid':
                  bookingForm.controls['phone_number'].touched &&
                  !bookingForm.controls['phone_number'].errors
              }"
            />

            <div
              class="text-danger mt-1"
              *ngIf="bookingForm.controls['phone_number'].touched && bookingForm.controls['phone_number'].invalid"
            >
              <span *ngIf="bookingForm.controls['phone_number'].errors?.['required']">
                {{ isAr ? 'ادخل رقم الموبايل' : 'Enter phone number' }}
              </span>

              <span
                *ngIf="
                  bookingForm.controls['phone_number'].errors?.['minlength'] ||
                  bookingForm.controls['phone_number'].errors?.['maxlength'] ||
                  bookingForm.controls['phone_number'].errors?.['pattern']
                "
              >
                {{ isAr ? 'ادخل رقم صحيح يبدأ بـ 01' : 'Enter a valid phone number starting with 01' }}
              </span>
            </div>
          </div>
        }

<div class="col-md-12 mb-3">
  <label>
    {{ isAr ? 'ميعاد الحجز' : 'Booking Date' }}
  </label>

  <div
    class="custom-date-field"
    [class.is-invalid-field]="
      bookingForm.controls['booking_date'].touched &&
      bookingForm.controls['booking_date'].errors
    "
  >
    <input
      #bookingDatePicker
      class="native-date-picker"
      type="datetime-local"
      formControlName="booking_date"
      [min]="minDate"
    />

    <button
      type="button"
      class="date-display-button"
      [class.placeholder]="!bookingForm.controls['booking_date'].value"
      (click)="openDatePicker(bookingDatePicker)"
    >
      <span>{{ bookingDateDisplay }}</span>
      <span class="date-icon">📅</span>
    </button>
  </div>

  <div
    class="text-danger mt-1"
    *ngIf="bookingForm.controls['booking_date'].touched && bookingForm.controls['booking_date'].invalid"
  >
    {{ isAr ? 'اختار ميعاد الحجز' : 'Choose booking date' }}
  </div>
</div>
      </div>

      <div class="booking-hint">
        <span>ℹ️</span>
        <p>
          {{
            isAr
              ? 'بعد إرسال الحجز، فريق Blue Box هيتواصل معاك لتأكيد الميعاد والتفاصيل.'
              : 'After submitting, Blue Box team will contact you to confirm the appointment.'
          }}
        </p>
              <p>
         {{ "clinicaddresstitle" | transloco }}
         <br>
         {{ "clinicaddress" | transloco }}

        </p>
      </div>

      <button type="submit" class="submit-booking-btn" [disabled]="contentReady">
        {{ isAr ? 'احجز الخدمة الآن' : 'Book Now' }}
      </button>
    </form>
  </div>
</section>